import {
  ElementId,
  EmbedType,
} from "@pages/Article/components/ArticleParagraphElements/utils/enums";
import { Type } from "@typings/enums";

export const PROBLEMATIC_SYMBOL_SAFE_MAPPING: Record<string, string> = {
  "‘": "'",
  "’": "'",
  "“": '"',
  "”": '"',
  "—": "-", // em dash to hyphen
  "–": "-", // en dash to hyphen
  "…": "...", // ellipsis to three dots
  "¶": "", // pilcrow to empty or you can use "P"
  "‹": "<",
  "›": ">",
};

export const HTML_ESCAPE_MAPPING: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#039;",
  "¶": "&#182;", // Pilcrow - New paragraph
  "#": "&#35;", // Hash - Insert space
  "^": "&#94;", // Caret - Insert text
  "~": "&#126;", // Tilde - Approx.
  "…": "&hellip;", // Ellipsis
  "[": "&#91;",
  "]": "&#93;",
  "-": "&#45;", // Dash
  "–": "&ndash;", // En dash
  "—": "&mdash;", // Em dash
  "“": "&ldquo;", // Left double quote
  "”": "&rdquo;", // Right double quote
  "‘": "&lsquo;", // Left single quote
  "’": "&rsquo;", // Right single quote
  "(": "&#40;",
  ")": "&#41;",
  "/": "&#47;",
  "\\": "&#92;",
};

export const ELEMENT_TYPE_MAPPING: Record<string, Type> = {
  [ElementId.Embed]: Type.Embed,
  [ElementId.Youtube]: Type.YoutubeVideo,
  [ElementId.Brightcove]: Type.BrightcoveVideo,
  [ElementId.OmnyPodcast]: Type.OmnyPodcast,
  [ElementId.Box]: Type.Box,
  [ElementId.BoxTitle]: Type.BoxTitle,
  [ElementId.Graphics]: Type.Graphic,
  [ElementId.Table]: Type.Table,
  [ElementId.Quote]: Type.PullQuote,
  [ElementId.Datawrapper]: Type.DataWrapper,
  [ElementId.Podcast]: Type.PodcastWrapper,
  [ElementId.DynamicIframe]: Type.DynamicIframeWrapper,
  [ElementId.Flourish]: Type.Embed,
  [ElementId.X]: Type.Embed,
  [ElementId.Instagram]: Type.Embed,
  [ElementId.Tiktok]: Type.Embed,
  [ElementId.Facebook]: Type.Embed,
  [ElementId.Image]: Type.Image,
  [ElementId.Accordion]: Type.Accordion,
  [ElementId.YoutubeEmbed]: Type.YoutubeVideo,
};

export const ELEMENT_TAG_MAPPING: Record<string, Type> = {
  p: Type.Paragraph,
  ul: Type.ListBulleted,
  ol: Type.ListNumbered,
  h1: Type.SubHead,
  h2: Type.SubHead,
  h3: Type.SubHead,
  h4: Type.SubHead,
  h5: Type.SubHead,
  h6: Type.SubHead,
  hr: Type.HorizontalRow,
  table: Type.Table,
};

export const EMBED_TAG_MAPPING: Record<string, EmbedType> = {
  [ElementId.Flourish]: EmbedType.Flourish,
  [ElementId.X]: EmbedType.X,
  [ElementId.Instagram]: EmbedType.Instagram,
  [ElementId.Tiktok]: EmbedType.Tiktok,
  [ElementId.Facebook]: EmbedType.Facebook,
  [ElementId.Embed]: EmbedType.Embed,
};
